export class LoginItem {
    email: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/pages/login/login-item.ts